import { APP_NAME } from "../constants/environment";
import { configureStore, Store } from "@reduxjs/toolkit";
import { CurriedGetDefaultMiddleware } from "@reduxjs/toolkit/dist/getDefaultMiddleware";

import authApi from "./api";
import rootReducers from "./reducers/rootReducers";
import { RootState } from "./types/rootReducers";

const middleware = (getDefaultMiddleware: CurriedGetDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: false,
  }).concat(authApi.middleware);

const localAuthenticationStore: Store<RootState> = configureStore({
  reducer: rootReducers,
  middleware,
  devTools: {
    name: `${APP_NAME}-store`,
  },
});

export const getStoreWithState = (preloadedState?: RootState) =>
  configureStore({
    reducer: rootReducers,
    preloadedState,
    middleware,
  });

export default localAuthenticationStore;
